module.exports = __webpack_public_path__ + "img/20180306_101254-min.42e1f323.jpg";